import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  YearlyOverviewMonth,
  CompanyService,
  CommunicationManagerService,
  NameFilter,
  MonthlyOverviewDetailed,
  FinanceService,
} from '@ops/shared-types';

@Injectable({ providedIn: 'root' })
export class CompanyFinanceService {
  selectedCompany$;
  selectedMonth = new BehaviorSubject<YearlyOverviewMonth | null>(null);

  selectedYear?: number;

  constructor(
    private financeService: FinanceService,
    private companyService: CompanyService,
    private communicationManagerService: CommunicationManagerService
  ) {
    this.selectedCompany$ = this.companyService.selectedCompany$.asObservable();
  }

  selectCompany(companyFilter: NameFilter) {
    this.companyService.selectedCompany$.next(companyFilter);
  }

  getCompanyFilters() {
    return this.financeService.getCompanyFilters(false);
  }

  getYearlyOverviewData(companyId: string, year?: number) {
    this.selectedYear = year ? year : new Date().getFullYear();

    return this.communicationManagerService
      .get(`company/overview/yearly/${this.selectedYear}`, [
        { headerName: 'companyId', headerValue: companyId },
      ])
      .pipe
      //tap(() => this.loadingService.setLoading(false))
      () as Observable<YearlyOverviewMonth>;
  }

  getDetailedMonthlyData(companyId: string, month: number, year?: number) {
    this.selectedYear = year ? year : new Date().getFullYear();
    return this.communicationManagerService.postAndGetJson(
      `company/detailed/monthly`,
      {
        year: this.selectedYear,
        month,
      },
      [{ headerName: 'companyId', headerValue: companyId }]
    ) as Observable<MonthlyOverviewDetailed>;
  }
}
